__turbopack_context__.v({
  "status": "status-module-scss-module__umbgoG__status",
  "status-close": "status-module-scss-module__umbgoG__status-close",
  "status-close-hidden": "status-module-scss-module__umbgoG__status-close-hidden",
  "status-close-icon": "status-module-scss-module__umbgoG__status-close-icon",
  "status-container": "status-module-scss-module__umbgoG__status-container",
  "status-container-large": "status-module-scss-module__umbgoG__status-container-large",
  "status-error": "status-module-scss-module__umbgoG__status-error",
  "status-error-rect": "status-module-scss-module__umbgoG__status-error-rect",
  "status-hide": "status-module-scss-module__umbgoG__status-hide",
  "status-success": "status-module-scss-module__umbgoG__status-success",
  "status-success-rect": "status-module-scss-module__umbgoG__status-success-rect",
  "status-text": "status-module-scss-module__umbgoG__status-text",
});
